import React from 'react';

import {Table} from 'react-bootstrap';

import './index.css';

const UsersChangesTable = ({data = [], onDateClick, onRowClick}) => {
    const rows = data.map(item => {
        return (
            <tr key={item.day} onClick={() => onRowClick(item.day)}>
                <td>{item.day}</td>
                <td>{item.subscribed}</td>
                <td>{item.unsubscribed}</td>
                <td>{item.subscribedTotal}</td>
                <td>{item.unsubscribedTotal}</td>
                <td>{item.unsubscribePercent} %</td>
                <td>{item.dailyUnsubscribed} %</td>
            </tr>
        );
    });

    return (
        <Table bordered responsive className="users-chnages-table">
            <thead>
                <tr>
                    <th onClick={onDateClick}>Date</th>
                    <th>Subscribed</th>
                    <th>Unsubscribed</th>
                    <th>Subscribed Total</th>
                    <th>Unsubscribed Total</th>
                    <th>% Total Unsusbcribed</th>
                    <th>% Daily Unsubscribed</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
}

export default UsersChangesTable;


// WEBPACK FOOTER //
// ./src/scenes/UsersChanges/components/UsersChangesTable/index.js